<template >
  <div class="loading-animation">
    <div class="dot" :style="{ background }"></div>
    <div class="dot" :style="{ background }"></div>
    <div class="dot" :style="{ background }"></div>
  </div>
</template>
<script>
export default {
  props: {
    background: {
      type: String,
      default: '#333'
    }
  }
}
</script>
<style lang="less" scoped>
.loading-animation {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 32px;
  height: 32px;

  .dot {
    width: 8px;
    height: 8px;
    opacity: 0.4;
    background-color: #999;
    border-radius: 100%;
    animation-duration: 0.5s;
    animation-name: dotani;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-timing-function: cubic-bezier(0.11, 0, 0.5, 0);

    &:nth-child(1) {
      animation-delay: 0.2s;
    }
    &:nth-child(2) {
      animation-delay: 0.4s;
    }
    &:nth-child(3) {
      animation-delay: 0.6s;
    }
  }
}

@keyframes dotani {
  0% {
    transform: translateY(0);
    opacity: 0.4;
  }

  100% {
    transform: translateY(4px);
    opacity: 0.9;
  }
}
</style>